import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import { get_all_debit_notes } from "../../../../Controllers/Purchases/DebitNotes";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Purchases/DebitNotes/tables";
import headers from "../../../../Data/Tables/Purchases/DebitNotes/headers";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import ActionButton from "../../../../Componets/Buttons/action";

const DebitNotesTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    fetchData({
      ...data,
      currentPage: data?.currentPage || 1,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
    });
  };

  const actiondata = (data) => {
    fetchData({
      currentPage: pagination?.currentPage,
    });
  };

  const fetchData = async (tabledata = {}) => {
    try {
      setLoader(true);
      const data = {
        search: tabledata?.search,
        supplier: tabledata?.supplier,
        date: tabledata?.date,
        page: tabledata?.currentPage,
      };

      const debitNotes = await get_all_debit_notes(data);
      if (debitNotes?.status) {
        let tableData = [];
        debitNotes?.data?.data?.map((value, index) => {
          tableData?.push({
            path: `/app/purchases/orders/view/${value?.purchase_order?._id}`,
            Number: `#DN-${value?.number}`,
            "Purchase Order": value?.purchase_order?.number ? `#PO-${value?.purchase_order?.number}` : "-",
            Supplier: value?.supplier?.name,
            Date: moment(value?.date).format("MMMM Do YYYY"),
            Reason: value?.reason,
            Total: value?.total?.toFixed(3),
            "Created By": value?.created_by?.name,
            Action: (
              <ActionButton
                view={`/app/purchases/debit-notes/view/${value?._id}`}
                id={value?._id}
                api="delete-debit-note"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: debitNotes?.data?.currentPage,
          totalCount: debitNotes?.data?.totalCount,
          totalPages: debitNotes?.data?.totalPages,
        });

        setBody(tableData);
        setLoader(false);
      } else {
        toast?.error(debitNotes?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default DebitNotesTable;